import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import BusyButton from 'scoreboard/components/busy-button'
import conductor from 'scoreboard/components/conductor'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import ServerErrorDetailsDialog from 'scoreboard/components/server-error-details-dialog'
import unwrapModel from 'scoreboard/components/unwrap-model'
import Xhr from 'scoreboard/components/xhr'
import template from './export-status-dialog.hbs'

var ExportStatusDialog = Backbone.View.extend({

	className: 'export-status-dialog dialog-message',

	events: {
		'click .download' : 'onDownload',
		'click .close' : 'onClose',
		'click .additional-details': 'onClickAdditionalDetails'
	},

	/**
	 * @property {Alert} [model] Provided if showing a download ready alert
	 *
	 * @param {String} [options.heading] Default is "Preparing Export"
	 *
	 * @param {Boolean} [alertPopup=false] true indicates that this has been popped
	 * up as an alert to indicate the download is complete. false indicates that
	 * this has been popped up as the export starts
	 *
	 * @params {Boolean} [forPrint=false]
	 */
	initialize: function(options = {}) {
		this.options = options
		this.createdAt = new Date()
	},

	render: function() {
		this.preparing()
		if (this.model) {
			if (this.model.isExportFailed()) {
				this.exportFailed(this.model, this.model.get('stackTrace'))
			} else {
				this.fileReady(this.model)
			}
		} else {
			this.busyButton = new BusyButton({ el: this.$('.close') }).loading()
		}

		this.$el.toggleClass('is-alert-popup', this.options.alertPopup)

		return this
	},

	preparing: function() {
		this.$el.empty().append(template({
			download: this.model,
			heading: _.defaultTo(this.options.heading, this._lookup('common.export.preparing'))
		}))
	},

	/**
	 * When a long running download is available.
	 * @param {Alert} alert
	 */
	fileReady: function(alert) {
		const unrapped = unwrapModel(alert)
		// Push notifications use `properties`, persisted alerts have label/url as main properties
		const {label} = _.get(unrapped, 'properties', unrapped)
		let fileName = highlight(label)
		const message = i18n.get('common.export.fileready.message', fileName)
		this._applyAlertModel(alert, 'common.export.ready.title', message)
		this.$('.button').toggleClass('is-not-displayed')
	},

	/**
	 * @param {Alert} alert
	 */
	exportFailed: function(alert, stackTrace) {
		this.stackTrace = stackTrace
		this._applyAlertModel(alert, 'common.export.error.title', alert.getExportFailedMessage())
		this.$('.cancel, .download').addClass('is-not-displayed')

		if (this.stackTrace) {
			this.$('.additional-details-container').removeClass('is-not-displayed')
		}
	},

	_applyAlertModel: function (alert, titleKey, message) {
		this.model = alert
		const title = this._lookup(i18n.get(titleKey))
		this._updateMessages(title, message, true)
	},

	/**
	 * When a download is ready before export is run in the background
	 */
	downloadReady: function() {
		this._updateMessages(this._lookup('common.export.ready.title'),
			this._lookup('common.export.ready.message'))
	},

	/**
	 * Lets the user know their export will complete in the background
	 * and they'll receive a future notification
	 *
	 * @param {Number} exportId required to correlate fileReady push events to open dialog
	 * @param {String} [title]
	 * @param {String} [message]
	 */
	notReady: function(exportId, title, message) {
		this.exportId = exportId
		this._updateMessages(title || this._lookup('common.export.notready.title'),
			message || this._lookup('common.export.notready.message'))
	},

	_updateMessages: function(title, message, hasHtml) {
		this.$('h1').text(i18n.get(title))
		if (hasHtml) {
			this.$('.message').html(message)
		} else {
			this.$('.message').text(i18n.get(message))
		}
		if (this.busyButton) {
			this.busyButton.once('animation-complete', () => this.busyButton.enable())
			this.busyButton.done()
		}
	},

	/**
	 * Invoking this function will cause the dialog to invoke conductor.reload
	 * when it is closed by the user.  The use case for this is to reload the DOM
	 * after very large reports are exported and they are known to lock up the
	 * browser (#36540)
	 */
	markForReload: function() {
		this.mustReload = true
	},

	onClose: function() {
		this._markRead()
	},

	onDownload() {
		new Xhr().download({
			url: `api/alerts/${this.model.id}/file`
		})
		this._markRead()
		this.trigger('done')
	},

	onClickAdditionalDetails() {
		appDisplay.dialog(
			new ServerErrorDetailsDialog({
				title: i18n.get('common.error.technicalDetails'),
				banner: i18n.get('common.export.error.title'),
				stackTrace: this.stackTrace
			})
		)
	},

	_lookup: function(key) {
		return i18n.get(key + (this.options.forPrint ? '.forPrint' : ''))
	},

	_markRead: function() {
		if (this.model) {
			$.post(`api/alerts/read/${this.model.id}`)
		}
	},

	remove: function() {
		if (this.mustReload) {
			conductor.reload()
		}
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.busyButton], 'remove')
	}

})

export default ExportStatusDialog

ExportStatusDialog.__filename__ = 'components/export/export-status-dialog.js'
